/* ============================================================================
   tne-mini-form.js — Candidatura rápida flutuante (homepage)
   DistribuidorTopBioEuropa

   - Abre/fecha o card (pill → card que sobe). Esc + click-fora + botão X fecham.
   - Validação client-side leve dos 3 campos + consentimento (mesma filosofia
     do tne-formulario.js, em versão compacta).
   - Honeypot anti-spam: cancela o submit silenciosamente se preenchido.
   - Auto-abre o card no estado de sucesso (data-just-submitted), para a
     visitante ver a confirmação após o reload do Shopify /contact.

   Re-inicializa em shopify:section:load (Theme Editor).
   ============================================================================ */
(function () {
  'use strict';

  function init(root) {
    var widget = (root || document).querySelector('[data-tne-mini-form]');
    if (!widget || widget.dataset.tneMiniInit === '1') return;
    widget.dataset.tneMiniInit = '1';

    var pill = widget.querySelector('[data-tne-mini-pill]');
    var card = widget.querySelector('[data-tne-mini-card]');
    var closeBtn = widget.querySelector('[data-tne-mini-close]');
    var form = widget.querySelector('form');

    if (!pill || !card) return;

    // JS disponível → o card passa a ser controlado por data-open/CSS
    // (remove o [hidden] que serve de fallback sem JS).
    card.removeAttribute('hidden');

    function open() {
      widget.setAttribute('data-open', 'true');
      pill.setAttribute('aria-expanded', 'true');
      // foco no primeiro campo (se não for o estado de sucesso)
      var firstField = card.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
      if (firstField) {
        window.setTimeout(function () { try { firstField.focus(); } catch (e) {} }, 280);
      }
    }

    function close() {
      widget.setAttribute('data-open', 'false');
      pill.setAttribute('aria-expanded', 'false');
    }

    pill.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', function () {
      close();
      try { pill.focus(); } catch (e) {}
    });

    // Esc fecha.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && widget.getAttribute('data-open') === 'true') {
        close();
        try { pill.focus(); } catch (e2) {}
      }
    });

    // Click fora fecha.
    document.addEventListener('click', function (e) {
      if (widget.getAttribute('data-open') !== 'true') return;
      if (!e.target.closest('[data-tne-mini-form]')) close();
    });

    if (form) attachValidation(form);

    // Sucesso → abre automaticamente para mostrar a confirmação.
    if (widget.getAttribute('data-just-submitted') === 'true') {
      open();
    }
  }

  /* ------------------------------------------------------------------------
     Validação compacta
     ------------------------------------------------------------------------ */
  function fieldError(field) {
    if (field.disabled) return '';
    if (field.type === 'checkbox') {
      return field.required && !field.checked ? 'Necessário aceitar para continuar.' : '';
    }
    var value = (field.value || '').trim();
    if (field.required && value === '') return 'Campo obrigatório.';
    if (field.type === 'email' && value !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'Email inválido.';
    }
    if (field.type === 'tel' && value !== '' && value.replace(/\D/g, '').length < 7) {
      return 'Telefone demasiado curto.';
    }
    return '';
  }

  function setError(field, message) {
    var wrapper = field.closest('.tne-mini-form__field') ||
                  field.closest('.tne-mini-form__consent') ||
                  field.parentElement;
    if (!wrapper) return;
    var errorEl = wrapper.querySelector('.tne-mini-form__field-error');

    if (message) {
      if (field.type !== 'checkbox') {
        field.classList.add('is-invalid');
        field.setAttribute('aria-invalid', 'true');
      } else {
        wrapper.classList.add('is-invalid');
      }
      if (!errorEl) {
        errorEl = document.createElement('span');
        errorEl.className = 'tne-mini-form__field-error';
        wrapper.appendChild(errorEl);
      }
      errorEl.textContent = message;
    } else {
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
      wrapper.classList.remove('is-invalid');
      if (errorEl) errorEl.remove();
    }
  }

  function attachValidation(form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('input'));

    fields.forEach(function (field) {
      if (field.id === 'tne-mini-hp' || field.type === 'hidden') return;
      var evt = (field.type === 'checkbox') ? 'change' : 'blur';
      field.addEventListener(evt, function () { setError(field, fieldError(field)); });
      field.addEventListener('input', function () {
        if (field.classList.contains('is-invalid')) setError(field, fieldError(field));
      });
    });

    form.addEventListener('submit', function (e) {
      // Honeypot — bot preencheu → cancela silenciosamente.
      var hp = form.querySelector('#tne-mini-hp');
      if (hp && hp.value.trim() !== '') {
        e.preventDefault();
        return;
      }

      var firstInvalid = null;
      fields.forEach(function (field) {
        if (field.id === 'tne-mini-hp' || field.type === 'hidden') return;
        var msg = fieldError(field);
        setError(field, msg);
        if (msg && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        e.preventDefault();
        try { firstInvalid.focus(); } catch (err) {}
        return;
      }

      var submitBtn = form.querySelector('[data-tne-mini-submit]');
      if (submitBtn) {
        submitBtn.dataset.loading = 'true';
        submitBtn.disabled = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
